import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useProduct(id: string) {
    const { productService } = useService();
    const { data, isLoading, isFetching } = useQuery(['product', id], () => productService.getProduct(id));
    return { product: data, isLoading, isFetching } as const;
}
